module.exports = __webpack_public_path__ + "img/54.187d16d0.png";